namespace RioERP.Enquiry {
    export namespace PermissionKeys {
        export const General = "Enquiry:General";

        namespace EnquiryManagement {
            export const Delete = "Enquiry:EnquiryManagement:Delete";
            export const Modify = "Enquiry:EnquiryManagement:Modify";
            export const View = "Enquiry:EnquiryManagement:View";
        }
    }
}
